<template>
	<!-- star -->

	<div class="kejipage_wrap">
		<nav2></nav2>
		<banner2 :bannerH="h1" :bannerP="P1" :bannerImg="Img1"></banner2>

		<!-- 解决方案 -->
		<div class="solution-view">
			<div class="com-title">
				<h3>热门行业解决方案
					<p>POPULAR INDUSTRY SOLUTIONS</p>
				</h3>
			</div>

			<div class="solution-cell">
				<div class="solution-list" v-for="(item, index) in arrList" :key="index">
					<div class="solution-content">
						<img :src="item.url" alt="" />
						<div class="solution-text">
							<h3>{{item.title}}</h3>
							<p>{{item.span}}</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 全部解决方案 -->
		<div class="all-solution-view">
			<div class="all-view">
				<div class="com-title">
					<h3>全部解决方案
						<p>ALL SOLUTIONS</p>
					</h3>
				</div>

				<!-- 按钮板块 -->
				<div class="btn">
					<div class="btn_cont">
						<div
							:class="active === item.url ? 'active' : ''"
							v-for="(item, index) in newsList"
							:key="index"
							@click="NewsDetails(item.url)"
						>
							{{ item.title }}
						</div>
					</div>
				</div>
				<router-view></router-view>
			</div>
		</div>
		
		
		<!-- end -->
	</div>
</template>

<script>
import banner2 from "../components/banner.vue";
import nav2 from "../components/nav.vue";
export default {
	name: "keji",
	components: {
		nav2,
		banner2,
	},
	data() {
		return {
			h1: "解决方案",
			P1: "服务创造价值",
			Img1: require("../assets/img/keji/keji.png"),
			arrList: [
				{
					url: require("../assets/img/img_factory.png"),
					title: "工厂",
					span: "人脸识别班牌是当今校园文化建设、数字化建设的系统之一。",
				},
				{
					url: require("../assets/img/img_school.png"),
					title: "学校",
					span: "人脸识别班牌是当今校园文化建设、数字化建设的系统之一。",
				},
				{
					url: require("../assets/img/img_hospital.png"),
					title: "医院",
					span: "人脸识别班牌是当今校园文化建设、数字化建设的系统之一。",
				},
				{
					url: require("../assets/img/img_market.png"),
					title: "商场",
					span: "学校为每个教室配置一个前端班牌一体机，一般安装在教室门口或教室内，用来显示班级信息、当前课程信息、班级活动信息以及学校的通知信息。",
				},
				{
					url: require("../assets/img/img_chargingstation.png"),
					title: "充电桩",
					span: "人脸识别班牌是当今校园文化建设、数字化建设的系统之一。",
				},
				{
					url: require("../assets/img/img_photovoltaic.png"),
					title: "光伏",
					span: "学校为每个教室配置一个前端班牌一体机，一般安装在教室门口或教室内，用来显示班级信息、当前课程信息、班级活动信息以及学校的通知信息。",
				}
			],
			active: "energy",
			newsList: [
				{
					title: "能源管理系统",
					url: "energy",
				},
				{
					title: "变压器监控运维理管平台",
					url: "power",
				},
				{
					title: "电缆安全监测系统",
					url: "cable",
				},
			],
		};
	},
	watch: {
		$route: {
			// 值发生变化时的回调函数
			handler(now) {
				//..... // now: 变化之后的数据
				// old: 变化之前的数据
				let url = now.name;

				// console.log(url);
				// console.log(now, old);
				if (url.includes("energy")) {
					this.active = "energy";
				} else if (url.includes("power")) {
					this.active = "power";
				} else {
					this.active = "cable";
				}
			},
			immediate: true, //立即执行
		},
	},
	methods: {
		NewsDetails(url) {
			this.$router.push({
				name: url,
			});
			// this.active = url;
		},
	},
};
</script>
<style scoped>
.solution-view{
	width: 1400px;
	display: block;
    margin: 0 auto;
}
.solution-cell{
	display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    flex-wrap: wrap;
	margin-bottom: 30px;
}
.solution-list{
	width: 25%;
	padding: 10px 6px;
}
.solution-list:first-child{
	width: 50%;
}
.solution-list:last-child{
	width: 50%;
}
.solution-content{
	position: relative; 
}
.solution-content img{
	height: 200px;
	display: block;
}
.solution-text{
	position: absolute;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 2;
	background: rgba(0, 0, 0, 0.45);
	width: 100%;
	padding: 12px 15px 12px;
	color: #FFFFFF;
	height: 85px;
}
.solution-text h3{
	font-size: 16px;
	color: #FFFFFF;
}
.solution-text p{
	margin-top: 8px;
	font-size: 13px;
	line-height: 21px;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}
.all-solution-view{
	background-color: #FBFBFB;
}
.all-view{
	width: 1400px;
	display: block;
    margin: 0 auto;
	padding-bottom: 20px
}
.btn_cont {
	display: flex;
	width: 1400px;
	margin: 0 auto;
	display: -webkit-flex;
    display: flex;
    -webkit-justify-content: center;
    justify-content: center;
}
.btn_cont div {
	text-align: center;
	font-size: 16px;
	font-family: PingFangSC-Regular, PingFang SC;
	font-weight: 400;
	color: #444444;
	line-height: 40px;
	margin-right: 18px;
	min-width: 185px;
	padding: 0 12px;
	height: 40px;
	border-radius: 6px;
	cursor: pointer;
	position: relative;
}
.active:after {
	content: " ";
	position: absolute;
	bottom: 0;
	left: 50%;
	z-index: 2;
	background: #4CCE9D !important;
	height: 3px;
	width: 70%;
	transform: translate(-50%, 0);
}
.solution-card{
	box-shadow: 0px 0px 12px -2px rgba(0, 0, 0, 0.12);
	background-color: #ffffff;
	margin: 30px 0 ;
	padding: 30px 30px;
	font-size: 14px;
}
</style>
